import React, { useEffect } from 'react';
import logoImg from '../assets/img/LOGO.png';
import hilazasImg from '../assets/img/hilazas.jpeg';
import hilazasImgPng from '../assets/img/hilazas.png';
import hilazaBlancaImg from '../assets/img/hilaza_blanca2.webp';
import hilazaBlancaImg2 from '../assets/img/hilaza_blanca.webp';
import nylonTexturizadoImg from '../assets/img/NYLON-TEXTURIZADO-70_24_2-PART-13.jpg';
import telasNylonImg from '../assets/img/nylon alta tenacidad.png';
import nylonNegroImg from '../assets/img/nylon_negro.jpg';
import hilosBlancosImg from '../assets/img/hilos blancos.png';
import hilosImg from '../assets/img/hilos.png';
import hilosWebpImg from '../assets/img/hilos.webp';
import elasticosImg from '../assets/img/RAMDOM-ELASTICOS.jpg';
import elasticosEcuadorImg from '../assets/img/Elasticos_Ecuador_03-1.jpg';
import creacionHilosImg from '../assets/img/creacion_hilos.jpg';
import creacionHilosPngImg from '../assets/img/creacion_hilos.png';
import mediasImg from '../assets/img/medias1.jpg';
import medias2Img from '../assets/img/medias2.jpg';
import maquinaTejerImg from '../assets/img/maquina-para-tejer-medias-computarizada-D_NQ_NP_814517-MPE27152320741_042018-F.jpg';
import cordoneaAlgodonImg from '../assets/img/cordones_algodon.jpg';
import shoeLaceImg from '../assets/img/shoe-lace.png';
import hiloDentalImg from '../assets/img/hilo dental.png';
import retazosImg from '../assets/img/retazos.jpeg';
import redPescaImg from '../assets/img/red de pezca.png';
import redPesca2Img from '../assets/img/red de pezca 2.png';
import canchaImg from '../assets/img/cancha.png';
import tiposTelasImg from '../assets/img/tipos-de-tela-para-camisetas-de-futbol.webp';
import enkaLogoImg from '../assets/img/Enka-logo.png';
import cupoCreditoPdf from '../assets/pdf/CUPO DE CREDITO.pdf';
import politicaPrivacidadPdf from '../assets/pdf/RESVELTEX SAS POLITICA DE TRATAMIENTO DE DATOS PERSONALES.pdf';
import styles from '../assets/css/styles.css';

const Home = () => {
  useEffect(() => {
    // Smooth scrolling para los enlaces de navegación
    const handleSmoothScroll = (e) => {
      if (e.target.getAttribute('href')?.startsWith('#')) {
        e.preventDefault();
        const target = document.querySelector(e.target.getAttribute('href'));
        if (target) {
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }
    };

    // Función para manejar cotizaciones de productos
    const handleProductQuote = (e) => {
      e.preventDefault();
      const productName = e.target.getAttribute('data-product');
      
      // Scroll al formulario
      const contactSection = document.querySelector('#contacto');
      if (contactSection) {
        contactSection.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
        
        // Después del scroll, preseleccionar opciones
        setTimeout(() => {
          const tipoConsulta = document.getElementById('tipo-consulta');
          const mensaje = document.getElementById('mensaje');
          
          if (tipoConsulta) {
            tipoConsulta.value = 'cotizacion';
          }
          
          if (mensaje && productName) {
            mensaje.value = `Hola, me interesa solicitar una cotización para ${productName}. Por favor envíenme información detallada sobre precios, disponibilidad y condiciones de compra.`;
            mensaje.focus();
          }
        }, 1000);
      }
    };

    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', handleSmoothScroll);
    });

    // Agregar event listeners para botones de cotización
    document.querySelectorAll('.product-quote-btn').forEach(btn => {
      btn.addEventListener('click', handleProductQuote);
    });

    // Funcionalidad del menú hamburguesa - Versión mejorada
    const initializeMenu = () => {
      const menuToggle = document.getElementById('menuToggle');
      const navLinks = document.getElementById('navLinks');
      
      if (!menuToggle || !navLinks) {
        // Si los elementos no están disponibles, reintentar después de un breve delay
        setTimeout(initializeMenu, 100);
        return;
      }

      const handleMenuToggle = (e) => {
        e.preventDefault();
        e.stopPropagation();
        
        // Toggle de las clases activas
        menuToggle.classList.toggle('active');
        navLinks.classList.toggle('active');
        
        // Logging para debug (puedes remover esto después)
        console.log('Menu toggled:', {
          menuToggleActive: menuToggle.classList.contains('active'),
          navLinksActive: navLinks.classList.contains('active')
        });
      };

      const handleLinkClick = () => {
        menuToggle.classList.remove('active');
        navLinks.classList.remove('active');
      };

      const handleOutsideClick = (e) => {
        if (!menuToggle.contains(e.target) && !navLinks.contains(e.target)) {
          menuToggle.classList.remove('active');
          navLinks.classList.remove('active');
        }
      };

      // Agregar event listeners
      menuToggle.addEventListener('click', handleMenuToggle);

      // Cerrar menú al hacer clic en un enlace
      navLinks.querySelectorAll('a').forEach(link => {
        link.addEventListener('click', handleLinkClick);
      });

      // Cerrar menú al hacer clic fuera
      document.addEventListener('click', handleOutsideClick);
      
      // Guardar referencias para cleanup
      window.menuHandlers = {
        toggle: handleMenuToggle,
        linkClick: handleLinkClick,
        outsideClick: handleOutsideClick,
        menuToggle,
        navLinks
      };
    };

    // Inicializar menú inmediatamente
    initializeMenu();

    // Efecto de scroll para elementos
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
        }
      });
    }, observerOptions);

    // Observar elementos para animaciones
    setTimeout(() => {
      document.querySelectorAll('.feature-card, .product-card').forEach(el => {
        el.style.opacity = '0';
        el.style.transform = 'translateY(30px)';
        el.style.transition = 'all 0.6s ease';
        observer.observe(el);
      });
    }, 100);

    // Funciones mejoradas para el formulario
    const validateEmail = (email) => {
      const re = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
      return re.test(email);
    };

    const validatePhone = (phone) => {
      // Acepta formatos colombianos e internacionales
      const re = /^(\+?57\s?)?[0-9]{7,10}$|^(\+?[1-9]\d{1,14})$/;
      return re.test(phone.replace(/[\s\-\(\)]/g, ''));
    };

    const validateName = (name) => {
      const re = /^[a-zA-ZáéíóúÁÉÍÓÚñÑüÜ\s]{2,50}$/;
      return re.test(name.trim());
    };

    const showFieldError = (field, message) => {
      const formGroup = field.closest('.form-group');
      let errorElement = formGroup.querySelector('.error-message');
      
      if (!errorElement) {
        errorElement = document.createElement('div');
        errorElement.className = 'error-message';
        errorElement.style.color = '#e74c3c';
        errorElement.style.fontSize = '0.85rem';
        errorElement.style.marginTop = '0.5rem';
        errorElement.style.padding = '0.3rem 0.5rem';
        errorElement.style.backgroundColor = '#ffeaea';
        errorElement.style.borderRadius = '4px';
        errorElement.style.border = '1px solid #f5c6cb';
        errorElement.style.animation = 'shake 0.3s ease-in-out';
        formGroup.appendChild(errorElement);
      }
      
      errorElement.textContent = message;
      field.style.borderColor = '#e74c3c';
      field.style.backgroundColor = '#fef9f9';
    };

    const clearFieldError = (field) => {
      const formGroup = field.closest('.form-group');
      const errorElement = formGroup.querySelector('.error-message');
      
      if (errorElement) {
        errorElement.remove();
      }
      
      field.style.borderColor = '';
      field.style.backgroundColor = '';
    };

    const showSuccessField = (field) => {
      field.style.borderColor = '#28a745';
      field.style.backgroundColor = '#f8fff9';
    };

    // Función para mostrar notificaciones
    const showNotification = (message, type = 'info') => {
      // Remover notificaciones previas
      const existingNotifications = document.querySelectorAll('.notification');
      existingNotifications.forEach(notification => notification.remove());

      const notification = document.createElement('div');
      notification.className = `notification notification-${type}`;
      notification.style.cssText = `
        position: fixed;
        top: 20px;
        right: 20px;
        padding: 1rem 1.5rem;
        border-radius: 8px;
        color: white;
        font-weight: 500;
        z-index: 10000;
        max-width: 400px;
        box-shadow: 0 4px 15px rgba(0,0,0,0.2);
        animation: slideInRight 0.3s ease-out;
        backdrop-filter: blur(10px);
      `;

      // Estilos según el tipo
      if (type === 'success') {
        notification.style.background = 'linear-gradient(135deg, #27ae60, #2ecc71)';
      } else if (type === 'error') {
        notification.style.background = 'linear-gradient(135deg, #e74c3c, #c0392b)';
      } else {
        notification.style.background = 'linear-gradient(135deg, #3498db, #2980b9)';
      }

      notification.innerHTML = `
        <div style="display: flex; align-items: center; justify-content: space-between;">
          <span>${message}</span>
          <button onclick="this.parentElement.parentElement.remove()" style="background: none; border: none; color: white; font-size: 1.2rem; cursor: pointer; margin-left: 1rem;">×</button>
        </div>
      `;

      document.body.appendChild(notification);

      // Auto-remover después de 5 segundos
      setTimeout(() => {
        if (notification.parentElement) {
          notification.style.animation = 'slideOutRight 0.3s ease-in';
          setTimeout(() => notification.remove(), 300);
        }
      }, 5000);
    };

    // Función para mostrar el email como respaldo
    const showEmailBackup = (data) => {
      const emailContent = `
Hola equipo de Resveltex SAS,

Han recibido una nueva consulta a través del sitio web:

📋 INFORMACIÓN DEL CLIENTE:
- Nombre: ${data.nombre}
- Empresa: ${data.empresa || 'No especificada'}
- Email: ${data.email}
- Teléfono: ${data.telefono || 'No especificado'}
- Tipo de Consulta: ${data.tipoConsulta || 'Contacto general'}

💬 MENSAJE:
${data.mensaje}

---
Este mensaje fue enviado desde el formulario de contacto de resveltex.com
Fecha: ${new Date().toLocaleString('es-CO')}
      `.trim();

      // Crear modal con el email
      const modal = document.createElement('div');
      modal.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0.8);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 10001;
        backdrop-filter: blur(5px);
      `;

      modal.innerHTML = `
        <div style="
          background: white;
          border-radius: 12px;
          padding: 2rem;
          max-width: 600px;
          width: 90%;
          max-height: 80vh;
          overflow-y: auto;
          box-shadow: 0 10px 30px rgba(0,0,0,0.3);
          animation: slideIn 0.3s ease-out;
        ">
          <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 1.5rem;">
            <h3 style="margin: 0; color: #2e2a73; font-size: 1.5rem;">📧 Email Preparado</h3>
            <button onclick="this.closest('.modal').remove()" style="
              background: none;
              border: none;
              font-size: 1.5rem;
              cursor: pointer;
              color: #666;
              padding: 0.5rem;
              border-radius: 50%;
              transition: background 0.2s;
            " onmouseover="this.style.background='#f0f0f0'" onmouseout="this.style.background='transparent'">×</button>
          </div>
          
          <div style="
            background: #f8f9fa;
            border: 1px solid #e9ecef;
            border-radius: 8px;
            padding: 1.5rem;
            margin-bottom: 1.5rem;
            font-family: monospace;
            white-space: pre-wrap;
            font-size: 0.9rem;
            line-height: 1.5;
            color: #333;
            max-height: 300px;
            overflow-y: auto;
          ">${emailContent}</div>
          
          <div style="display: flex; gap: 1rem; justify-content: flex-end;">
            <button onclick="copyToClipboard('${emailContent.replace(/'/g, "\\'")}')" style="
              background: linear-gradient(135deg, #3498db, #2980b9);
              color: white;
              border: none;
              padding: 0.75rem 1.5rem;
              border-radius: 6px;
              cursor: pointer;
              font-weight: 500;
              transition: transform 0.2s;
            " onmouseover="this.style.transform='scale(1.05)'" onmouseout="this.style.transform='scale(1)'">
              📋 Copiar Contenido
            </button>
            <button onclick="window.open('mailto:ventas@resveltex.com?subject=${encodeURIComponent(`Nueva consulta de ${data.nombre} - ${data.tipoConsulta || 'Contacto'}`)}&body=${encodeURIComponent(emailContent)}')" style="
              background: linear-gradient(135deg, #27ae60, #2ecc71);
              color: white;
              border: none;
              padding: 0.75rem 1.5rem;
              border-radius: 6px;
              cursor: pointer;
              font-weight: 500;
              transition: transform 0.2s;
            " onmouseover="this.style.transform='scale(1.05)'" onmouseout="this.style.transform='scale(1)'">
              📧 Abrir Email
            </button>
          </div>
        </div>
      `;

      modal.className = 'modal';
      document.body.appendChild(modal);

      // Función para copiar al portapapeles
      window.copyToClipboard = (text) => {
        navigator.clipboard.writeText(text).then(() => {
          showNotification('Contenido copiado al portapapeles', 'success');
        }).catch(() => {
          // Fallback para navegadores antiguos
          const textArea = document.createElement('textarea');
          textArea.value = text;
          document.body.appendChild(textArea);
          textArea.select();
          document.execCommand('copy');
          document.body.removeChild(textArea);
          showNotification('Contenido copiado al portapapeles', 'success');
        });
      };
    };

    // Validación en tiempo real
    const addRealTimeValidation = () => {
      const nombre = document.getElementById('nombre');
      const email = document.getElementById('email');
      const telefono = document.getElementById('telefono');
      const mensaje = document.getElementById('mensaje');

      if (nombre) {
        nombre.addEventListener('blur', () => {
          if (nombre.value.trim()) {
            if (!validateName(nombre.value)) {
              showFieldError(nombre, 'El nombre solo puede contener letras y espacios');
            } else {
              clearFieldError(nombre);
              showSuccessField(nombre);
            }
          }
        });

        nombre.addEventListener('input', () => {
          if (nombre.value.trim().length >= 2 && validateName(nombre.value)) {
            clearFieldError(nombre);
            showSuccessField(nombre);
          }
        });
      }

      if (email) {
        email.addEventListener('blur', () => {
          if (email.value.trim()) {
            if (!validateEmail(email.value)) {
              showFieldError(email, 'Por favor ingresa un correo electrónico válido');
            } else {
              clearFieldError(email);
              showSuccessField(email);
            }
          }
        });
      }

      if (telefono) {
        telefono.addEventListener('blur', () => {
          if (telefono.value.trim()) {
            if (!validatePhone(telefono.value)) {
              showFieldError(telefono, 'Por favor ingresa un número de teléfono válido');
            } else {
              clearFieldError(telefono);
              showSuccessField(telefono);
            }
          }
        });
      }

      if (mensaje) {
        mensaje.addEventListener('input', () => {
          const length = mensaje.value.trim().length;
          const counter = mensaje.parentNode.querySelector('.char-counter');
          
          if (!counter) {
            const counterElement = document.createElement('div');
            counterElement.className = 'char-counter';
            counterElement.style.textAlign = 'right';
            counterElement.style.fontSize = '0.8rem';
            counterElement.style.color = '#666';
            counterElement.style.marginTop = '0.25rem';
            mensaje.parentNode.appendChild(counterElement);
          }
          
          const currentCounter = mensaje.parentNode.querySelector('.char-counter');
          currentCounter.textContent = `${length}/500 caracteres`;
          
          if (length > 500) {
            currentCounter.style.color = '#e74c3c';
          } else if (length >= 10) {
            currentCounter.style.color = '#28a745';
            clearFieldError(mensaje);
            showSuccessField(mensaje);
          } else {
            currentCounter.style.color = '#666';
          }
        });
      }
    };

    // Manejo del formulario
    const contactForm = document.getElementById('contactForm');
    if (contactForm) {
      addRealTimeValidation();
      
      const handleSubmit = (e) => {
        e.preventDefault();
        
        const nombre = document.getElementById('nombre');
        const empresa = document.getElementById('empresa');
        const email = document.getElementById('email');
        const telefono = document.getElementById('telefono');
        const tipoConsulta = document.getElementById('tipo-consulta');
        const mensaje = document.getElementById('mensaje');
        
        let isValid = true;
        
        // Limpiar errores previos
        [nombre, empresa, email, telefono, mensaje].forEach(field => {
          if (field) clearFieldError(field);
        });
        
        // Validar nombre
        if (!nombre.value.trim() || nombre.value.trim().length < 2) {
          showFieldError(nombre, 'El nombre es obligatorio y debe tener al menos 2 caracteres');
          isValid = false;
        } else if (!validateName(nombre.value)) {
          showFieldError(nombre, 'El nombre solo puede contener letras y espacios');
          isValid = false;
        } else {
          showSuccessField(nombre);
        }
        
        // Validar email
        if (!email.value.trim()) {
          showFieldError(email, 'El correo electrónico es obligatorio');
          isValid = false;
        } else if (!validateEmail(email.value)) {
          showFieldError(email, 'Por favor ingresa un correo electrónico válido');
          isValid = false;
        } else {
          showSuccessField(email);
        }
        
        // Validar teléfono (opcional pero si se llena debe ser válido)
        if (telefono.value.trim() && !validatePhone(telefono.value)) {
          showFieldError(telefono, 'Por favor ingresa un número de teléfono válido (ej: +57 300 123 4567)');
          isValid = false;
        } else if (telefono.value.trim()) {
          showSuccessField(telefono);
        }
        
        // Validar mensaje
        if (!mensaje.value.trim()) {
          showFieldError(mensaje, 'El mensaje es obligatorio');
          isValid = false;
        } else if (mensaje.value.trim().length < 10) {
          showFieldError(mensaje, 'El mensaje debe tener al menos 10 caracteres');
          isValid = false;
        } else if (mensaje.value.trim().length > 500) {
          showFieldError(mensaje, 'El mensaje no puede exceder los 500 caracteres');
          isValid = false;
        } else {
          showSuccessField(mensaje);
        }
        
        if (!isValid) {
          return;
        }
        
        const submitBtn = contactForm.querySelector('.submit-btn');
        const submitSpan = submitBtn.querySelector('span');
        const originalText = submitSpan.textContent;
        
        // Agregar clase loading y spinner
        submitBtn.classList.add('loading');
        submitSpan.textContent = 'Enviando';
        submitBtn.disabled = true;
        submitBtn.style.opacity = '0.8';
        submitBtn.style.cursor = 'not-allowed';
        
        // Función para enviar el formulario usando mailto (100% gratuito)
        try {
          // Recopilar datos del formulario
          const data = {
            nombre: nombre.value.trim(),
            empresa: empresa.value.trim(),
            email: email.value.trim(),
            telefono: telefono.value.trim(),
            tipoConsulta: tipoConsulta.value,
            mensaje: mensaje.value.trim()
          };

          // Crear el contenido del email
          const subject = `Nueva consulta de ${data.nombre} - ${data.tipoConsulta || 'Contacto'}`;
          const body = `
Hola equipo de Resveltex SAS,

Han recibido una nueva consulta a través del sitio web:

📋 INFORMACIÓN DEL CLIENTE:
- Nombre: ${data.nombre}
- Empresa: ${data.empresa || 'No especificada'}
- Email: ${data.email}
- Teléfono: ${data.telefono || 'No especificado'}
- Tipo de Consulta: ${data.tipoConsulta || 'Contacto general'}

💬 MENSAJE:
${data.mensaje}

---
Este mensaje fue enviado desde el formulario de contacto de resveltex.com
Fecha: ${new Date().toLocaleString('es-CO')}
          `.trim();

          // Crear enlaces para Gmail y mailto
          const gmailLink = `https://mail.google.com/mail/?view=cm&fs=1&to=ventas@resveltex.com&su=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
          const mailtoLink = `mailto:ventas@resveltex.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

          // Intentar abrir Gmail primero
          const gmailWindow = window.open(gmailLink, '_blank');
          
          // Si Gmail no se abre, intentar con mailto
          if (!gmailWindow || gmailWindow.closed || typeof gmailWindow.closed == 'undefined') {
            window.location.href = mailtoLink;
            showNotification('Se abrirá tu cliente de email. Si no funciona, copia este email: ventas@resveltex.com', 'success');
          } else {
            showNotification('Se abrirá Gmail en una nueva pestaña. Por favor envía el mensaje.', 'success');
          }

          // Mostrar el email como respaldo
          setTimeout(() => {
            showEmailBackup(data);
          }, 1000);

        } catch (error) {
          console.error('Error al preparar el email:', error);
          showNotification('Error al preparar el email. Por favor escribe directamente a ventas@resveltex.com', 'error');
        }
        
        // Resetear el botón después de un tiempo
        setTimeout(() => {
          submitBtn.classList.remove('loading');
          submitSpan.textContent = originalText;
          submitBtn.disabled = false;
          submitBtn.style.background = '';
          submitBtn.style.opacity = '1';
          submitBtn.style.cursor = 'pointer';
          
          // Limpiar campos
          contactForm.reset();
          [nombre, empresa, email, telefono, mensaje].forEach(field => {
            if (field) {
              clearFieldError(field);
              field.style.borderColor = '';
              field.style.backgroundColor = '';
            }
          });
          
          // Limpiar contador de caracteres
          const charCounter = contactForm.querySelector('.char-counter');
          if (charCounter) {
            charCounter.remove();
          }
        }, 4000);
      };

      contactForm.addEventListener('submit', handleSubmit);
    }

    // Cleanup
    return () => {
      // Limpiar smooth scroll listeners
      document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.removeEventListener('click', handleSmoothScroll);
      });
      
      // Limpiar product quote listeners
      document.querySelectorAll('.product-quote-btn').forEach(btn => {
        btn.removeEventListener('click', handleProductQuote);
      });
      
      // Limpiar event listeners del menú hamburguesa
      if (window.menuHandlers) {
        const { menuToggle, navLinks, toggle, linkClick, outsideClick } = window.menuHandlers;
        
        if (menuToggle) {
          menuToggle.removeEventListener('click', toggle);
        }
        
        if (navLinks) {
          navLinks.querySelectorAll('a').forEach(link => {
            link.removeEventListener('click', linkClick);
          });
        }
        
        document.removeEventListener('click', outsideClick);
        window.menuHandlers = null;
      }
      
      // Limpiar observer
      if (observer) {
        observer.disconnect();
      }
    };
  }, []);

  return (
    <div className="home-page">

      <header className="header">
        <nav className="nav container">
          <a href="#" className="logo">
            <img src={logoImg} alt="Resveltex S.A.S" className="logo-image" />
          </a>
          <ul className="nav-links" id="navLinks">
            <li><a href="#inicio">Inicio</a></li>
            <li><a href="#productos">Productos</a></li>
            <li><a href="#usos">Usos</a></li>
            <li><a href="#servicios">Servicios</a></li>
            <li><a href="#aliados">Aliados</a></li>
            <li><a href="#documentos">Documentos</a></li>
            <li><a href="#contacto">Contacto</a></li>
          </ul>
          <div className="menu-toggle" id="menuToggle">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </nav>
      </header>

      <section className="hero" id="inicio">
        <div className="container">
          <div className="hero-content">
            <h1>RESVELTEX S.A.S</h1>
            <p>Hilos de Calidad Premium para el Sector Textil e Industrial</p>
            <a href="#contacto" className="cta-button">Solicita tu Cotización</a>
          </div>
        </div>
      </section>

      <section className="features" id="servicios">
        <div className="container">
          <h2 className="section-title">¿Por qué elegir Resveltex?</h2>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">🧵</div>
              <h3>Calidad Superior</h3>
              <p>Hilos fabricados con los más altos estándares de calidad, garantizando resistencia y durabilidad en cada producto.</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">⚡</div>
              <h3>Entrega Rápida</h3>
              <p>Cumplimos con los tiempos de entrega establecidos, asegurando que sus proyectos nunca se retrasen.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">💼</div>
              <h3>Atención Personalizada</h3>
              <p>Nuestro equipo de expertos le brinda asesoría especializada para encontrar la solución perfecta.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🌱</div>
              <h3>Compromiso Ambiental</h3>
              <p>Procesos de fabricación eco-amigables que respetan el medio ambiente y las normativas internacionales.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">📈</div>
              <h3>Precios Competitivos</h3>
              <p>Ofrecemos los mejores precios del mercado sin comprometer la calidad de nuestros productos.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="products" id="productos">
        <div className="container">
          <h2 className="section-title">Catálogo de Productos</h2>
          <div className="products-grid">
            <div className="product-card">
              <div className="product-image">
                <img src={telasNylonImg} alt="Nylon Alta Tenacidad" />
              </div>
              <div className="product-info">
                <h3>NYLON ALTA TENACIDAD</h3>
                <div className="product-specs">
                  <p><strong>Procedencia:</strong> Nylon nacional de ENKA DE COLOMBIA</p>
                  <p><strong>Títulos:</strong> Entre 460 decitex y 2100 decitex</p>
                  <p><strong>Cuerdas:</strong> 1, 2 y 3 cabos</p>
                  <p><strong>Colores:</strong> Crudos y Negros</p>
                </div>
                <a href="#contacto" className="product-quote-btn" data-product="NYLON ALTA TENACIDAD">
                  Cotizar Ahora
                </a>
              </div>
            </div>
            <div className="product-card">
              <div className="product-image">
                <img src={hilosBlancosImg} alt="Poliester Texturizado" />
              </div>
              <div className="product-info">
                <h3>POLIESTER TEXTURIZADO</h3>
                <div className="product-specs">
                  <p><strong>Títulos:</strong> 150/1, 150/2, 150/3 y 150/4 cabos</p>
                  <p><strong>Poliester Stretch:</strong> 100/2</p>
                  <p><strong>Colores:</strong> Blanco Óptico y Negro</p>
                  <p><strong>Características:</strong> Alta resistencia y elasticidad</p>
                </div>
                <a href="#contacto" className="product-quote-btn" data-product="POLIESTER TEXTURIZADO">
                  Cotizar Ahora
                </a>
              </div>
            </div>
            <div className="product-card">
              <div className="product-image">
                <img src={nylonTexturizadoImg} alt="Nylon Texturizado" />
              </div>
              <div className="product-info">
                <h3>NYLON TEXTURIZADO</h3>
                <div className="product-specs">
                  <p><strong>Retorcidos:</strong> 70F24/2 y 110F24/2</p>
                  <p><strong>Torsión S y Z:</strong> 70F24/1, 78F68/1</p>
                  <p><strong>Especiales:</strong> 70F68/2 Abierto y compactado</p>
                  <p><strong>Aplicaciones:</strong> Uso industrial y textil</p>
                </div>
                <a href="#contacto" className="product-quote-btn" data-product="NYLON TEXTURIZADO">
                  Cotizar Ahora
                </a>
              </div>
            </div>
           
           
          
          </div>
        </div>
      </section>

      {/* Nueva Sección: Usos de nuestros hilos y hilazas */}
      <section className="applications" id="usos">
        <div className="container">
          <h2 className="section-title">Usos de Nuestros Hilos y Hilazas</h2>
          <p className="section-subtitle">Descubre la versatilidad de nuestros productos en diferentes industrias y aplicaciones</p>
          <div className="applications-grid">
            <div className="application-card">
              <div className="application-image">
                <img src={tiposTelasImg} alt="Ropa Deportiva" />
              </div>
              <div className="application-info">
                <h3>Ropa Deportiva y Camisetas</h3>
                <p>Nuestros hilos de poliéster texturizado y nylon proporcionan la elasticidad y resistencia necesarias para prendas deportivas de alto rendimiento.</p>
              </div>
            </div>
            <div className="application-card">
              <div className="application-image">
                <img src={medias2Img} alt="Medias y Calcetines" />
              </div>
              <div className="application-info">
                <h3>Medias y Calcetines</h3>
                <p>Hilos especializados que ofrecen comodidad, durabilidad y ajuste perfecto para todo tipo de medias deportivas e industriales.</p>
              </div>
            </div>
          
            <div className="application-card">
              <div className="application-image">
                <img src={shoeLaceImg} alt="Cordones Especializados" />
              </div>
              <div className="application-info">
                <h3>Cordones Especializados</h3>
                <p>Cordones técnicos con tratamientos especiales para aplicaciones que requieren mayor resistencia y durabilidad.</p>
              </div>
            </div>
            <div className="application-card">
              <div className="application-image">
                <img src={redPescaImg} alt="Redes de Pesca" />
              </div>
              <div className="application-info">
                <h3>Redes de Pesca</h3>
                <p>Hilos de nylon alta tenacidad ideales para la fabricación de redes de pesca resistentes al agua salada y condiciones extremas.</p>
              </div>
            </div>
            <div className="application-card">
              <div className="application-image">
                <img src={canchaImg} alt="Redes Deportivas" />
              </div>
              <div className="application-info">
                <h3>Redes Deportivas</h3>
                <p>Fabricación de redes para canchas deportivas, tenis, volleyball y otros deportes que requieren alta resistencia y durabilidad.</p>
              </div>
            </div>
            <div className="application-card">
              <div className="application-image">
                <img src={hiloDentalImg} alt="Hilo Dental" />
              </div>
              <div className="application-info">
                <h3>Hilo Dental Especializado</h3>
                <p>Hilos de alta calidad para aplicaciones de higiene personal, con tratamientos especiales para uso médico y odontológico.</p>
              </div>
            </div>
            <div className="application-card">
              <div className="application-image">
                <img src={maquinaTejerImg} alt="Industria Textil" />
              </div>
              <div className="application-info">
                <h3>Industria Textil</h3>
                <p>Nuestros hilos están diseñados para trabajar perfectamente en maquinaria textil moderna, garantizando eficiencia en la producción.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="partners" id="aliados">
        <div className="container">
          <h2 className="section-title">Nuestros Aliados Estratégicos</h2>
          <div className="partners-grid">
            <div className="partner-card">
              <div className="partner-logo">
                <img src={enkaLogoImg} alt="ENKA DE COLOMBIA" />
              </div>
              <div className="partner-info">
                <h3>ENKA DE COLOMBIA</h3>
                <p>Proveedor principal de nylon de alta calidad nacional. Líder en la producción de fibras sintéticas con más de 50 años de experiencia en el mercado colombiano.</p>
              </div>
            </div>
            <div className="partner-card">
              <div className="partner-logo">
                <img src={creacionHilosPngImg} alt="Tecnología Textil" />
              </div>
              <div className="partner-info">
                <h3>TECNOLOGÍAS TEXTILES</h3>
                <p>Socios estratégicos a nivel mundial en tecnologías textiles y maquinaria especializada. Contribuyen con innovación y equipos de última generación para la producción de hilos premium.</p>
              </div>
            </div>
            <div className="partner-card">
              <div className="partner-logo">
                <img src={hilosImg} alt="Distribución Especializada" />
              </div>
              <div className="partner-info">
                <h3>DISTRIBUCIÓN ESPECIALIZADA</h3>
                <p>Red de distribución nacional e internacional que garantiza la llegada de nuestros productos a todos los mercados con los más altos estándares de calidad.</p>
              </div>
            </div>
            <div className="partner-card">
              <div className="partner-logo">
                <img src={retazosImg} alt="Sostenibilidad" />
              </div>
              <div className="partner-info">
                <h3>COMPROMISO SOSTENIBLE</h3>
                <p>Alianzas enfocadas en el aprovechamiento responsable de materiales y la implementación de procesos eco-amigables en toda la cadena productiva.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="contact" id="contacto">
        <div className="container">
          <h2 className="section-title" style={{color: 'var(--dorado-premium)'}}>Contáctanos</h2>
          <div className="contact-content">
            <div className="contact-info">
              <h3>Información de Contacto</h3>
              <div className="contact-item">
                <i>📍</i>
                <span>Carrera 50 #79 Sur-101 BG 82<br/>La Estrella, Antioquia, Colombia</span>
              </div>
              <div className="contact-item">
                <i>📞</i>
                <span>+573127576928</span>
              </div>
              <div className="contact-item">
                <i>📧</i>
                <span>ventas@resveltex.com</span>
              </div>
              <div className="contact-item">
                <i>🕒</i>
                <span>Lun - Vie: 8:00 AM - 6:00 PM</span>
              </div>
            </div>
            <form className="contact-form" id="contactForm">
              <div className="form-group">
                <label htmlFor="nombre">Nombre Completo *</label>
                <input type="text" id="nombre" name="nombre" placeholder="Ingresa tu nombre completo" required />
              </div>
              <div className="form-group">
                <label htmlFor="empresa">Empresa</label>
                <input type="text" id="empresa" name="empresa" placeholder="Nombre de tu empresa (opcional)" />
              </div>
              <div className="form-group">
                <label htmlFor="email">Correo Electrónico *</label>
                <input type="email" id="email" name="email" placeholder="ejemplo@correo.com" required />
              </div>
              <div className="form-group">
                <label htmlFor="telefono">Teléfono</label>
                <input type="tel" id="telefono" name="telefono" placeholder="+57 300 123 4567" />
              </div>
              <div className="form-group">
                <label htmlFor="tipo-consulta">Tipo de Consulta</label>
                <select id="tipo-consulta" name="tipo-consulta">
                  <option value="">Selecciona una opción</option>
                  <option value="cotizacion">Solicitar Cotización</option>
                  <option value="informacion">Información de Productos</option>
                  <option value="distribucion">Ser Distribuidor</option>
                  <option value="soporte">Soporte Técnico</option>
                  <option value="otro">Otro</option>
                </select>
              </div>
              <div className="form-group">
                <label htmlFor="mensaje">Mensaje *</label>
                <textarea id="mensaje" name="mensaje" placeholder="Cuéntanos sobre tu proyecto, cantidad necesaria, colores específicos o cualquier consulta que tengas..." required></textarea>
              </div>
              <button type="submit" className="submit-btn">
                <span>Enviar Mensaje</span>
              </button>
            </form>
          </div>
        </div>
      </section>

      {/* Sección de Documentos */}
      <section className="documents" id="documentos">
        <div className="container">
          <h2 className="section-title">Documentos Importantes</h2>
          <div className="documents-grid">
            <div className="document-card">
              <div className="document-icon">
                <i>📄</i>
              </div>
              <div className="document-info">
                <h3>Cupo de Crédito</h3>
                <p>Información detallada sobre nuestras políticas de crédito, términos y condiciones para clientes empresariales.</p>
                <a href={cupoCreditoPdf} 
                   className="download-btn"
                   download="Resveltex_Cupo_Credito.pdf"
                   target="_blank"
                   rel="noopener noreferrer">
                  <span>📥</span>
                  Descargar PDF
                </a>
              </div>
            </div>
            <div className="document-card">
              <div className="document-icon">
                <i>🔒</i>
              </div>
              <div className="document-info">
                <h3>Política de Privacidad</h3>
                <p>Conoce cómo protegemos y tratamos tus datos personales de acuerdo con la normativa vigente.</p>
                <a href={politicaPrivacidadPdf} 
                   className="download-btn"
                   download="Resveltex_Politica_Privacidad.pdf"
                   target="_blank"
                   rel="noopener noreferrer">
                  <span>🔒</span>
                  Descargar PDF
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            
            {/* Información de la empresa */}
            <div className="footer-section">
              <div className="footer-logo">
                <img src={logoImg} alt="Resveltex S.A.S" className="footer-logo-img" />
              </div>
              <p className="footer-description">
                Especialistas en hilos de calidad premium para el Sector Texil e Industrial en Colombia.
              </p>
              <div className="footer-social">
                <a href="https://wa.me/573127576928" 
                   className="social-link" 
                   target="_blank" 
                   rel="noopener noreferrer"
                   title="WhatsApp">
                  <span>📱</span>
                </a>
                <a href="mailto:ventas@resveltex.com" 
                   className="social-link" 
                   title="Email">
                  <span>📧</span>
                </a>
                <a href="tel:+573127576928" 
                   className="social-link" 
                   title="Teléfono">
                  <span>📞</span>
                </a>
              </div>
            </div>

            {/* Enlaces y productos */}
            <div className="footer-section">
              <h4>Enlaces Rápidos</h4>
              <div className="footer-links-grid">
                <a href="#productos">Productos</a>
                <a href="#usos">Usos</a>
                <a href="#servicios">Servicios</a>
                <a href="#aliados">Aliados</a>
                <a href="#documentos">Documentos</a>
                <a href="#contacto">Contacto</a>
              </div>
            </div>

            {/* Información de contacto compacta */}
            <div className="footer-section">
              <h4>Contacto</h4>
              <div className="footer-contact-compact">
                <p>📍 Carrera 50 #79 Sur-101 BG 82<br/>La Estrella, Antioquia, Colombia</p>
                <p>📞 <a href="tel:+573127576928">+57 312 757 6928</a></p>
                <p>📧 <a href="mailto:ventas@resveltex.com">ventas@resveltex.com</a></p>
                <p>🕒 Lun - Vie: 8:00 AM - 6:00 PM</p>
              </div>
            </div>

          </div>

          {/* Sección inferior compacta */}
          <div className="footer-bottom">
            <div className="footer-copyright">
              <p>&copy; 2025 <strong>Resveltex S.A.S</strong> - Hilos de Calidad Premium</p>
            </div>
            
            <div className="footer-legal">
              <a href={politicaPrivacidadPdf} 
                 className="legal-link"
                 download="Resveltex_Politica_Privacidad.pdf"
                 target="_blank"
                 rel="noopener noreferrer">
                Política de Privacidad
              </a>
              <span className="separator">|</span>
              <a href={cupoCreditoPdf} 
                 className="legal-link"
                 download="Resveltex_Cupo_Credito.pdf"
                 target="_blank"
                 rel="noopener noreferrer">
                Cupo de Crédito
              </a>
            </div>
          </div>

        </div>
      </footer>

      {/* Botón de WhatsApp flotante */}
      <a href="https://wa.me/573127576928?text=Hola%20Resveltex,%20me%20interesa%20conocer%20más%20sobre%20sus%20hilos%20de%20calidad%20premium" 
         className="whatsapp-btn" 
         target="_blank" 
         rel="noopener noreferrer"
         title="Contáctanos por WhatsApp">
        <svg viewBox="0 0 24 24" width="24" height="24">
          <path fill="currentColor" d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.434 3.756"/>
        </svg>
      </a>
    </div>
  );
};

export default Home; 